import { Route, Routes } from "react-router-dom";
import "./App.css";
import AdminDashboard from "./Frontend/Admin/Admin-dashboard";
// import Nav from "./Frontend/UI/Navbar-footer/Nav";
import Home from "./Frontend/UI/Home";
import Aboutus from "./Frontend/UI/components/Aboutus";
import Login from "./Frontend/UI/Navbar-footer/Login";
import AdminLogin from "./Frontend/Admin/AdminLogin";
import ProtectedAdminRoute from "./Frontend/UI/components/ProtectedAdminRoute";
import { useAuth } from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SupportCase from "./Frontend/UI/components/SupportCase";
import RequestTable from "./Frontend/Admin/RequestTable";
import TabsView from "./Frontend/UI/components/TabsView";
import MembershipPlans from "./Frontend/UI/components/MembershipPlans";
import LegalIdentity from "./Frontend/UI/components/LegalIdentity";


// ✅ Import CasesProvider
import { CasesProvider } from "./Frontend/UI/components/Context/CasesContext";
import FrontPage from "./Frontend/UI/components/FrontPage";

function App() {
  const { handleLogout } = useAuth();

  return (
    <CasesProvider>  {/* ✅ Wrap everything here */}
      <div className="App">
        {/* <Nav /> */}
        <Routes>
          <Route path="/" element={<FrontPage />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<Aboutus />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/support" element={<SupportCase />} />
          <Route path="/request" element={<RequestTable />} />
          <Route path="/tabs" element={<TabsView />} />
          <Route path="/membership" element={<MembershipPlans />} />
          <Route path="/legal" element={<LegalIdentity />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedAdminRoute>
                <AdminDashboard onLogout={handleLogout} />
              </ProtectedAdminRoute>
            }
          />
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </CasesProvider>
  );
}

export default App;
